import { Component } from '@angular/core';
import { LabelService } from '../../shared/services/label.service';

@Component({
  selector: 'app-mobile-menu',
  templateUrl: 'mobilemenu.component.html',
})
export class MobileMenuComponent {
  public FILTER_BUTTON_LABEL: string;

  constructor(private labelService: LabelService) {
    this.FILTER_BUTTON_LABEL = this.labelService.getLabel('filterButtonLabel');
  }
}
